export const smallTimeBlockHeight = 10;
export const longClickDuration = 600;
